import styled from "styled-components";
import parseDate from "../../../../controllers/parseDate";
import getImageURL from "../../../../controllers/getImageURL";
import useWidth from "./useWidth";

const CertificateWrapper = styled.div`
  width: 100%;
  height: auto;
  background: #fdfbf5;
  border: 12px solid #c9a880;
  color: #ac7b41ff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  padding: 40px;
  position: relative;
  font-family: "Times New Roman", serif;
  position: relative;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  flex-direction: column;

  @media (max-width: 900px) {
    padding: 10px;
  }
`;

const BorderDecor = styled.div`
  position: absolute;
  top: 20px;
  left: 20px;
  right: 20px;
  border-radius: 5px;
  bottom: 20px;
  border: 2px solid #b0a690;
  pointer-events: none;

  border: 20px solid;
  border-image: repeating-linear-gradient(
      45deg,
      #5a5,
      #5a5 10px,
      #fff 10px,
      #fff 20px
    )
    20;
`;

const Content = styled.div`
  text-align: center;
  color: inherit;
  padding: 40px 0;
  z-index: 2;
`;

const Title = styled.h1`
  font-weight: bold;
  margin-bottom: 20px;
  color: inherit;

  @media (max-width: 900px) {
    font-size: 10px !important;
  }
`;

const SubText = styled.p`
  margin: 8px 0;
  @media (max-width: 900px) {
    font-size: 10px !important;
  }
`;

const Name = styled.h2`
  font-weight: bold;
  margin: 16px 0;
  color: inherit;
  @media (max-width: 900px) {
    font-size: 10px !important;
  }
`;

const Org = styled.h3`
  font-weight: bold;
  margin: 16px 0;
  color: inherit;
  @media (max-width: 900px) {
    font-size: 10px !important;
  }
`;

const Footer = styled.div`
  margin-top: 15px;
  @media (max-width: 900px) {
    font-size: 10px !important;
  }
`;

const Signature = styled.div`
  margin-top: 15px;
  font-weight: bold;
  color: inherit;
  @media (max-width: 900px) {
    font-size: 10px !important;
  }
`;

const CertImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 10px;
`;

const Simple = styled.div``;

const TopDecor = styled.img`
  width: 100%;
  object-fit: contain;
`;
const BottomDecor = styled.img`
  width: 100%;
  object-fit: contain;
`;
const LeftDecor = styled.img`
  height: 100%;
  object-fit: contain;
  position: absolute;
  left: 15px;
  top: 0;
`;
const RightDecor = styled.img`
  height: 100%;
  object-fit: contain;
  position: absolute;
  right: 15px;
  top: 0;
`;
const DecorRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: center;
`;

const LogoImage = styled.img`
  width: 50px;
  border-radius: 30px;
  height: auto;

  @media (max-width: 900px) {
    width: 50px;
  }
`;

export default function CertificateCardCore({ data, ngo, user }) {
  const [ref, width] = useWidth();
  console.log("width", width);

  let sizeMode = "LARGE";
  let fontSize1 = "22px";
  let fontSize2 = "20px";
  let fontSize3 = "15px";
  let fontSize4 = "15px";
  let decorSize = "40px";

  if (width < 400) {
    sizeMode = "SMALL";
    fontSize1 = "16px";
    fontSize2 = "13px";
    fontSize3 = "11px";
    fontSize4 = "11px";
    decorSize = "30px";
  }

  if (data.customCertificate) {
    return <CertImage ref={ref} src={getImageURL(data.customCertificate)} />;
  }

  return (
    <CertificateWrapper ref={ref} $sizeMode={sizeMode}>
      <TopDecor
        style={{ height: decorSize }}
        src="/certificate/certificate-top.png"
      />

      <DecorRow>
        <LeftDecor
          style={{ width: decorSize }}
          src="/certificate/certificate-left.png"
        />

        <Content>
          {/* <LogoImage src="/icons/apple-icon.png" /> */}
          <Title style={{ fontSize: fontSize1 }}>
            CERTIFICATE OF APPRECIATION
          </Title>
          <SubText style={{ fontSize: fontSize4 }}>This certifies that</SubText>
          <Name style={{ fontSize: fontSize1 }}>
            {user ? user.name : "Unknown"}
          </Name>
          <SubText style={{ fontSize: fontSize4 }}>
            has contributed valuable service to
          </SubText>
          <Org style={{ fontSize: fontSize2 }}>{ngo.name}</Org>
          <SubText style={{ fontSize: fontSize3 }}>{data.title}</SubText>
          <SubText style={{ fontSize: fontSize3 }}>{data.description}</SubText>
          <Footer style={{ fontSize: fontSize4 }}>
            Issued on: {parseDate(data.issuedOn)}
          </Footer>
          <Signature style={{ fontSize: fontSize4 }}>
            <Simple>{data.issuedBy}</Simple>
            <Simple>{data.issuerDesignation}</Simple>
          </Signature>
        </Content>

        <RightDecor
          style={{ width: decorSize }}
          src="/certificate/certificate-right.png"
        />
      </DecorRow>

      <BottomDecor
        style={{ height: decorSize }}
        src="/certificate/certificate-bottom.png"
      />
    </CertificateWrapper>
  );
}
